import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import HeaderMenu from '@/HeaderMenu';

const ClientLayoutComponent = ({ user, children }) => (
  <div className="min-h-screen flex flex-col font-['Open_Sans']">
    <header className="flex bg-[#2b313c] justify-center items-center h-[90px] text-white">
      <div className="flex h-full w-[76.5625%] min-w-[440px] items-center justify-between">
        <div className="w-1/3 h-[35px] flex items-center">
          <Link to="/orders" className="h-full">
            <img 
              src="/assets/img/logo_rede.svg" 
              alt="Logo Rede Vistorias" 
              className="max-h-full max-w-full"
            />
          </Link>
        </div>

        <div className="w-1/3 text-right flex justify-end items-center">
          <HeaderMenu credits={user?.accountBalance} />
        </div>
      </div>
    </header>
    <main className="flex-1">
      {children}
    </main>
  </div>
);

ClientLayoutComponent.propTypes = {
  user: PropTypes.object,
  children: PropTypes.node.isRequired,
};

ClientLayoutComponent.defaultProps = {
  user: { accountBalance: 0 },
};

export default ClientLayoutComponent;
